import { drawBlankGrid } from '@/threejs/utils/canvasPatterns';
import type { InputSource } from './types';

export const white: InputSource = {
  label: 'White',
  value: 'white',
  draw: (ctx, width, height) => {
    drawBlankGrid(ctx, width, height);
  },
};
